var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useCallback } from 'react';
var updateObserverOrCallback = function (observerOrCallback, stopLoading) {
    if (observerOrCallback && typeof observerOrCallback !== 'function') {
        return __assign(__assign({}, observerOrCallback), { complete: function () {
                var _a;
                stopLoading();
                (_a = observerOrCallback.complete) === null || _a === void 0 ? void 0 : _a.call(observerOrCallback);
            }, error: function (error) {
                var _a;
                stopLoading();
                (_a = observerOrCallback.error) === null || _a === void 0 ? void 0 : _a.call(observerOrCallback, error);
            }, unsubscribe: function (subscription) {
                var _a;
                stopLoading();
                (_a = observerOrCallback.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(observerOrCallback, subscription);
            } });
    }
    return function (error) {
        stopLoading();
        observerOrCallback === null || observerOrCallback === void 0 ? void 0 : observerOrCallback(error);
    };
};
function useLoadMore(relayLoadMore) {
    var _a = __read(useState(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    var loadMore = useCallback(function (pageSize, observerOrCallback, options) {
        setIsLoading(true);
        return relayLoadMore(pageSize, updateObserverOrCallback(observerOrCallback, function () { return setIsLoading(false); }), options);
    }, [relayLoadMore]);
    return {
        isLoading: isLoading,
        loadMore: loadMore,
    };
}
export default useLoadMore;
//# sourceMappingURL=hooks.js.map